/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetUserActive
 */
export interface SetUserActive {
    /**
     * 
     * @type {boolean}
     * @memberof SetUserActive
     */
    active: boolean;
}

/**
 * Check if a given object implements the SetUserActive interface.
 */
export function instanceOfSetUserActive(value: object): value is SetUserActive {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function SetUserActiveFromJSON(json: any): SetUserActive {
    return SetUserActiveFromJSONTyped(json, false);
}

export function SetUserActiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserActive {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
    };
}

export function SetUserActiveToJSON(json: any): SetUserActive {
    return SetUserActiveToJSONTyped(json, false);
}

export function SetUserActiveToJSONTyped(value?: SetUserActive | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
    };
}

